import {
    getPageInfo,
    getUserInfo,
} from "@services/tracking/trackers/pageImpressionTracker";
import TrackingService from "@services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { EventTypes } from "@services/tracking/types/eventTypes";

import { getProductTrackingInfo } from "@factory/Tracking/product.model";

import { ProductImpressionTrackingInfo } from "../types/trackingInfo/productImpressionTrackingInfo";
import { ProductImpressionModel } from "../types/trackingInfo/productImpressionmodel";

const trackAddToWishlistImpression = (productModel: ProductImpressionModel) => {
    trackWishlistChangeImpression(
        EventTypes.AddToWishlistImpression,
        getProductTrackingInfo(productModel),
    );
};

const trackWishlistChangeImpression = (
    eventName: string,
    impression: ProductImpressionTrackingInfo,
) => {
    const event: TypedAnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: eventName,
        payload: {
            eventData: impression,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo(),
        },
    };

    TrackingService.track(event);
};

export { trackAddToWishlistImpression };
